// extracted by mini-css-extract-plugin
module.exports = {"coinSelectMenu":"InitModal_coinSelectMenu__Q6-Su","coin":"InitModal_coin__1tNJu","coinText":"InitModal_coinText__P6cxx"};